/**
* @author wangjunfeng
*/

<!--<template>
  <div class="sy-container__header">
    <slot name="header"></slot>
  </div>
</template>-->

<script>
export default {
  name: 'sy-header',
  render () {
    return (
      <div class="sy-container__header">
        <div class="sy-container__header-inner">
          { this.$slots.default }
        </div>
      </div>
    )
  }
}
</script>

<style scoped lang="scss">
  .sy-container__header {
    width: 100%;
    min-width: 1200px;
    //height: 73px;
    position: relative;
    .sy-container__header-inner {
      //box-shadow: 0 4px 2px rgba(0, 0, 0, .03);
      border-bottom: 1px solid #EFF2F9;
      position: relative;
      z-index: 5;
      width: 100%;
    }
  }
</style>
